import Redactor from '../../redactor.esm.min.js'
import { registerToolbarButton } from '../registerButton'
import { ANCHOR_EMOJI, anchorEditorHtml, applyAnchorEditorState } from '../../htmlForEmail'

class MpAnchorPlugin {
    static defaultOptions = {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.165 20.0001V8.79993C11.165 8.33877 11.5388 7.96497 12 7.96497C12.4612 7.96497 12.835 8.33877 12.835 8.79993V20.0001C12.8349 20.4612 12.4611 20.8351 12 20.8351C11.5389 20.8351 11.1651 20.4612 11.165 20.0001Z" fill="black"/>
<path d="M6.39941 11.165C6.86039 11.1653 7.23438 11.539 7.23438 12C7.23438 12.461 6.86039 12.8347 6.39941 12.835H4.88477C5.07165 14.4277 5.78728 15.9211 6.93262 17.0664C8.27632 18.4101 10.0987 19.165 11.999 19.165C13.8993 19.165 15.7217 18.4101 17.0654 17.0664C18.2108 15.9211 18.9264 14.4277 19.1133 12.835H17.5986C17.1377 12.8347 16.7637 12.461 16.7637 12C16.7637 11.539 17.1377 11.1653 17.5986 11.165H19.999C20.4602 11.165 20.834 11.5388 20.834 12C20.834 14.3432 19.903 16.5902 18.2461 18.2471C16.5892 19.904 14.3422 20.835 11.999 20.835C9.65584 20.835 7.40884 19.904 5.75195 18.2471C4.09507 16.5902 3.16406 14.3432 3.16406 12C3.16406 11.7785 3.25161 11.5658 3.4082 11.4092C3.5648 11.2526 3.77757 11.165 3.99902 11.165H6.39941Z" fill="black"/>
<path d="M13.5645 6.40033C13.5645 5.53613 12.8641 4.83511 12 4.8349C11.1357 4.8349 10.4346 5.536 10.4346 6.40033C10.4348 7.26448 11.1358 7.96478 12 7.96478C12.864 7.96457 13.5642 7.26435 13.5645 6.40033ZM15.2344 6.40033C15.2342 8.18666 13.7863 9.63449 12 9.6347C10.2135 9.6347 8.76486 8.18679 8.76465 6.40033C8.76465 4.61369 10.2134 3.16498 12 3.16498C13.7865 3.16519 15.2344 4.61382 15.2344 6.40033Z" fill="black"/>
</svg>`,
        listIcon:
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5H3C2.44772 5 2 4.55228 2 4ZM5 8C5 7.44772 5.44772 7 6 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H6C5.44772 9 5 8.55228 5 8ZM3 12C3 11.4477 3.44772 11 4 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H4C3.44772 13 3 12.5523 3 12ZM6 16C6 15.4477 6.44772 15 7 15H13C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H7C6.44772 17 6 16.5523 6 16ZM10 20C10 19.4477 10.4477 19 11 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H11C10.4477 21 10 20.5523 10 20Z"/></svg>'
    }

    static defaultLang = {
        en: {
            mpAnchor: {
                anchor: 'Anchor',
                'add-or-change-id': 'Add or change anchor name...',
                add: 'Add',
                update: 'Update',
                'insert-anchor-list': 'Table of Contents'
            }
        }
    }

    constructor(app, options = {}) {
        this.app = app
        this.options = options
        this._editingAnchorName = null
        this._onSelectionChange = () => {
            setTimeout(() => this._updateButtonContent(), 10)
        }
    }

    start() {
        const button = {
            icon: this.options.icon,
            command: 'mpAnchor.popup',
            title: '## mpAnchor.anchor ##',
            position: { after: 'link' }
        }
        registerToolbarButton(this.app, 'mpAnchor', button)
        this.app.control.add('mpAnchor', { ...button, position: { after: ['add', 'format'] } })

        const listButton = {
            icon: this.options.listIcon || this.options.icon,
            command: 'mpAnchor.insertAnchorList',
            title: '## mpAnchor.insert-anchor-list ##',
            position: { after: 'mpAnchor' }
        }
        // The control bar is hidden. The more-formatting menu only shows names that exist on buttonsObj.
        const buttonsObj = this.app.getOption('buttonsObj')
        if (buttonsObj && typeof buttonsObj === 'object') {
            buttonsObj.mpAnchorList = { ...listButton, name: 'mpAnchorList' }
        }
        if (this.app.inline && typeof this.app.inline.add === 'function') {
            this.app.inline.add('mpAnchorList', listButton)
        }
        this.app.control.add('mpAnchorList', { ...listButton, position: { after: ['add', 'format'] } })

        this.app.on('click', this._onSelectionChange)
        this.app.on('key:up', this._onSelectionChange)
    }

    stop() {
        this.app.off('click', this._onSelectionChange)
        this.app.off('key:up', this._onSelectionChange)
    }

    insertAnchorList() {
        this.app.dropdown.close()
        const anchors = this._findAllAnchors()
        if (!anchors.length) return
        this.app.insertHtml(this._buildAnchorListHtml(anchors))
    }

    _editorRoot() {
        return this.app.host.getEditor()
    }

    popup(_params, { button, el } = {}) {
        this.app.saveSelection()
        const anchorEl = this._getAnchorElementAtCursor()
        const existingName = anchorEl ? anchorEl.getAttribute('name') || anchorEl.getAttribute('id') || '' : ''
        this._editingAnchorName = existingName || null
        const form = this.app.form.create({
            data: { id: existingName || '' },
            command: 'mpAnchor.save',
            items: {
                id: { type: 'input', placeholder: '## mpAnchor.add-or-change-id ##' }
            }
        })
        this.app.dropdown.create('mpAnchor', { form, focus: 'id' })
        this.app.dropdown.open(button || el)
        this._appendAddButton()
    }

    _appendAddButton() {
        const form = this.app.dropdown.getForm()
        const input = form && form.getInput ? form.getInput('id') : null
        const formItem = input && input.closest ? input.closest('.rx-form-item') : null
        if (!formItem) return

        const isEditing = !!this._editingAnchorName
        const btnText = isEditing
            ? this.app.getLang('mpAnchor.update') || 'Update'
            : this.app.getLang('mpAnchor.add') || 'Add'
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'rx-mpAnchor-add'
        btn.textContent = btnText
        formItem.style.display = 'flex'
        formItem.style.flexDirection = 'row'
        formItem.style.alignItems = 'center'
        formItem.style.gap = '8px'
        formItem.appendChild(btn)
        btn.addEventListener('click', () => this._onAddClick())
    }

    _onAddClick() {
        const form = this.app.dropdown.getForm()
        if (!form) return
        this.save(form.getData ? form.getData() : {}, { form })
    }

    _updateButtonContent() {
        const hasAnchor = !!this._getAnchorElementAtCursor()
        const button = this.app.toolbar.getButton('mpAnchor')
        if (button && button.setState) {
            button.setState({ active: hasAnchor })
        }
    }

    save(data = {}, ctx = {}) {
        const form = ctx.form || this.app.dropdown.getForm()
        const rawName = this._getInputValue(data, form)
        this.app.dropdown.close()
        if (!rawName) return
        const name = this._sanitizeId(rawName)
        if (!name) return
        const editingName = this._editingAnchorName
        this._editingAnchorName = null
        this.app.restoreSelection()
        const anchorEl = editingName ? this._findAnchorInEditor(editingName) : null
        if (anchorEl && anchorEl.parentNode) {
            applyAnchorEditorState(anchorEl, name)
        } else {
            this.app.insertHtml(anchorEditorHtml(name))
        }
    }

    _getInputValue(data, form) {
        if (data && typeof data === 'object' && data.id != null && data.id !== '') {
            return String(data.id).trim()
        }
        if (form && form.getData) {
            const value = form.getData('id')
            if (value != null && value !== '') return String(value).trim()
        }
        const dropdown = this.app.dropdown && this.app.dropdown.getEl && this.app.dropdown.getEl()
        if (dropdown) {
            const inp = dropdown.querySelector && dropdown.querySelector('input')
            if (inp && inp.value != null) return String(inp.value).trim()
        }
        return ''
    }

    _anchorNodes() {
        const root = this._editorRoot()
        if (!root || !root.querySelectorAll) return []
        return root.querySelectorAll('a[data-rx-anchor], a[name]')
    }

    _findAllAnchors() {
        const out = []
        this._anchorNodes().forEach((el) => {
            const name = el.getAttribute('name') || el.getAttribute('id') || ''
            if (name) out.push({ name, el })
        })
        return out
    }

    _getAnchorLabel(anchorEl) {
        const name = anchorEl.getAttribute('name') || anchorEl.getAttribute('id') || ''
        const parent = anchorEl.parentElement
        if (!parent) return name
        const tag = (parent.tagName || '').toUpperCase()
        if (/^H[1-6]$/.test(tag)) {
            const text = (parent.textContent || '').replace(ANCHOR_EMOJI, '').trim()
            if (text) return text.slice(0, 80)
        }
        let sibling = anchorEl.previousSibling
        while (sibling) {
            const text = (sibling.textContent || sibling.nodeValue || '').trim()
            if (text) return text.slice(0, 80)
            sibling = sibling.previousSibling
        }
        sibling = anchorEl.nextSibling
        while (sibling) {
            const text = (sibling.textContent || sibling.nodeValue || '').trim()
            if (text) return text.slice(0, 80)
            sibling = sibling.nextSibling
        }
        return name
    }

    _buildAnchorListHtml(anchors) {
        let items = ''
        anchors.forEach((anchor) => {
            const label = this._escapeHtml(this._getAnchorLabel(anchor.el))
            const href = this._escapeHtml(anchor.name)
            items += `<li><a href="#${href}">${label}</a></li>`
        })
        if (items.length) {
            items = `<ul>${items}</ul>`
        }
        return items
    }

    _findAnchorInEditor(oldName) {
        if (!oldName) return null
        let found = null
        this._anchorNodes().forEach((el) => {
            if (found) return
            const name = el.getAttribute('name') || el.getAttribute('id') || ''
            if (name === oldName) found = el
        })
        return found
    }

    _getAnchorElementAtCursor() {
        const selection = this.app.getService('selection')
        if (!selection.getRange()) return null
        const nodes = selection.getNodes({ tags: ['a'] }) || []
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i]
            if (node && (node.getAttribute('data-rx-anchor') || node.getAttribute('name'))) {
                return node
            }
        }
        return null
    }

    _sanitizeId(value) {
        return (
            value
                .replace(/\s+/g, '-')
                .replace(/[^A-Za-z0-9\-_:.]/g, '')
                .replace(/^-+|-+$/g, '')
                .replace(/-+/g, '-')
                .slice(0, 100) || ''
        )
    }

    _escapeHtml(str) {
        const div = document.createElement('div')
        div.textContent = str
        return div.innerHTML
    }
}

Redactor.addPlugin('mpAnchor', MpAnchorPlugin)
